export const gradientBackground = [
    {
        id: 1,
        gradient: 'linear-gradient(90deg, hsla(152, 100%, 50%, 1) 0%, hsla(186, 100%, 69%, 1) 100%)'
    },
    {
        id: 2,
        gradient: 'linear-gradient(90deg, hsla(217, 100%, 50%, 1) 0%, hsla(186, 100%, 69%, 1) 100%)'
    },
    {
        id: 3,
        gradient: 'linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%)'
    },
    {
        id: 4,
        gradient: 'linear-gradient(90deg, hsla(197, 100%, 63%, 1) 0%, hsla(294, 100%, 55%, 1) 100%)'
    },
    {
        id: 5,
        gradient: 'linear-gradient(90deg, hsla(33, 100%, 53%, 1) 0%, hsla(58, 100%, 68%, 1) 100%)'
    },
    {
        id: 6,
        gradient: 'linear-gradient(to right, #00b4db, #0083b0)'
    },
    {
        id: 7,
        gradient: 'linear-gradient(to right, rgb(242, 112, 156), rgb(255, 148, 114))'
    },
    {
        id: 8,
        gradient: 'linear-gradient( 109.6deg, rgba(156,252,248,1) 11.2%, rgba(110,123,251,1) 91.1% )'
    },
    {
        id: 9,
        gradient: 'linear-gradient(25deg,#d64c7f,#ee4758 50%)'
    },
    {
        id: 10,
        gradient: 'linear-gradient(to right, #ff6e7f, #bfe9ff)'
    },
    {
        id: 11,
        gradient: 'linear-gradient(90deg, hsla(154, 100%, 76%, 1) 0%, hsla(234, 100%, 83%, 1) 50%, hsla(288, 100%, 81%, 1) 100%)'
    },
    {
        id: 12,
        gradient: 'linear-gradient(90deg, hsla(31, 90%, 76%, 1) 0%, hsla(302, 82%, 76%, 1) 100%)'
    },
    {
        id: 13,
        gradient: 'linear-gradient(90deg, hsla(177, 87%, 79%, 1) 0%, hsla(235, 89%, 70%, 1) 100%)'
    },
    {
        id: 14,
        gradient: 'linear-gradient(90deg, hsla(210, 90%, 80%, 1) 0%, hsla(212, 93%, 49%, 1) 100%)'
    },
]